import { Programme } from 'src/resources/api/programme/types.api';

//
//

export type MerchantByCodeQuery = {
  code: string;
  pledgeTaken?: boolean;
};

export type MerchantResponse = Merchant;

export type Merchant = {
  category: any;
  code: string;
  country: string;
  currency: string;
  email: string;
  id: string;
  industryCode: string;
  name: string;
  platform: string;
  pledgeTaken: boolean;
  referrerMerchantCode: string;
  shortDescription: string;
  thumbnailUrl: string;
  url: string;
  preferredBasketCode: string;
  companySize: string;
  programmes: Programme[] | [];
  tradingName: string;
  businessRegistrationType: string;
  companyRegistrationId: string;
  stateProvince: string;
  cityTown: string;
  addressLine1: string;
  addressLine2: string;
  postcodeZip: string;
  serviceFee?: number | null;
};

//

export type PatchMerchantPayload = {
  currency?: string;
  name?: string;
  preferredBasketCode?: string;
  tradingName?: string;
  businessRegistrationType?: string;
  companyRegistrationId?: string;
  stateProvince?: string;
  cityTown?: string;
  addressLine1?: string;
  addressLine2?: string;
  postcodeZip?: string;
  pledgeTaken?: boolean;
};

//

export type CreateMerchantPayload = {
  country: string;
  currency?: string;
  email: string;
  industryCode: string | null;
  makeEmailAdmin: boolean;
  merchantReferrerCode: string;
  name: string;
  platform: string;
  companySize: string;
};

//

export type AcceptMerchantInvitationPayload = {
  email: string;
};

//

export enum ReferrerMerchantType {
  EVENT = 'EVENT',
  PARTNER = 'PARTNER',
}

// merchant user types

export type MerchantUserResponse = MerchantUser[];

export type MerchantUser = {
  carbonUserId: string;
  emailAddress: string;
  firstName: string;
  lastName?: string;
  lastSignedInAt?: number;
  title?: string;
  merchantUserId: string;
  merchantId: string;
  merchantRole: keyof typeof MerchantUserRole;
  invitationId?: string;
};

export const MerchantUserRole = {
  ADMIN: 'ADMIN',
  SUPER_USER: 'SUPER_USER',
  REPORTING_USER: 'REPORTING_USER',
} as const;

//

export type MerchantUserInvitationResponse = MerchantUserInvitation;

type MerchantUserInvitation = {
  emailAddress: string;
  expired: boolean;
  expiresAt: number;
  id: string;
  inviterCarbonUserId: string;
  merchantCode: string;
};
